import { render, staticRenderFns } from "./VehicleInformation.vue?vue&type=template&id=5a2a1c52&scoped=true&"
import script from "./VehicleInformation.vue?vue&type=script&lang=js&"
export * from "./VehicleInformation.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInformation.vue?vue&type=style&index=0&id=5a2a1c52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a1c52",
  null
  
)

export default component.exports